<template>
	<form
		data-vv-scope="personal-details"
		@submit.prevent="action('personal-details')"
	>
		<div class="row pt-3">
			<div class="col-5 col-lg-2">
				<p id="user-firstname-head"
							data-test="profileFirstNameLabel">
					First Name
				</p>
			</div>
			<div class="col-7 col-lg-5">
				<!--First Name Input field and error-->
				<input
					v-validate="'required|min:3|max:32|alpha'"
					type="text"
					:class="(userFormError &&
                 errors.has('personal-details.firstname'))?'is-invalid':''"
					class="form-control"
					name="firstname"
					placeholder="First Name"
					id="user-firstname-input"
					v-model="userData.firstname"
					autocomplete="off"
					data-ismobileonly="false"
					:disabled="!editUserData"
					style="text-transform:capitalize"
					data-test="profileFirstNameInput"
				>
				<div
					class="invalid-feedback"
					v-if="userFormError"
					v-show="errors.has('personal-details.firstname')"
					id="user-firstname-error"
					data-test="profileFirstNameInputError"
				>
					{{errors.first('personal-details.firstname')}}
				</div>
			</div>
		</div>
		<div class="row pt-3">
			<div class="col-5 col-lg-2">
				<p id="user-lastname-head"
							data-test="profileLastNameLabel">
					Last Name
				</p>
			</div>
			<div class="col-7 col-lg-5">
				<!--Last Name Input field and error-->
				<input
					v-validate="'required|min:3|max:32|alpha'"
					type="text"
					:class="(userFormError &&
                 errors.has('personal-details.lastname'))?'is-invalid':''"
					class="form-control"
					name="lastname"
					placeholder="Last Name"
					id="user-lastname-input"
					v-model="userData.lastname"
					autocomplete="off"
					data-ismobileonly="false"
					:disabled="!editUserData"
					data-test="profileLastNameInput"
				>
				<div
					class="invalid-feedback"
					v-if="userFormError"
					v-show="errors.has('personal-details.lastname')"
					id="user-lastname-error"
					data-test="profileLastNameInputError"
				>
					{{errors.first('personal-details.lastname')}}
				</div>
			</div>
		</div>
		<div class="row pt-3">
			<div class="col-5 col-lg-2">
				<p id="user-email-head"
							data-test="profileEmailLabel">
					Email Id
				</p>
			</div>
			<div class="col-7 col-lg-5">
				<input
					type="email"
					name="email"
					disabled="true"
					class="form-control"
					placeholder="Email Id"
					id="user-email-input"
					aria-describedby="email"
					v-model="userData.email"
					data-test="profileEmailInput"
				>
			</div>
		</div>
		<div class="row pt-3">
			<div class="col-5 col-lg-2">
				<p id="user-phone-head"
							data-test="profilePhnNoLabel">
					Phone
				</p>
			</div>
			<div class="col-7 col-lg-5">
				<input
					type="tel"
					name="phone"
					disabled="true"
					class="form-control"
					placeholder="Phone Number"
					id="user-phone-input"
					aria-describedby="phone"
					v-model="userData.phone_number"
					data-test="profilePnNoInput"
				>
			</div>
		</div>
		<div
			class="row mb-3 pt-3"
			v-if="editUserData"
		>
			<button
				class="btn btn-outline-dark btn-xs ml-3"
				@click.prevent="cancelAction"
				id="user-cancel-btn"
				data-test="profileEditUserInfoCancelBtn"
			>
				Cancel
			</button>
			<button
				class="btn btn-primary btn-xs ml-3"
				id="user-save-btn"
				data-test="profileEditUserInfoSaveBtn"
			>
				Save and Continue
			</button>
		</div>
	</form>
</template>

<script>
export default {
	name: 'personnal-details-form',
	data () {
		return {
			userFormError: false,
			editUserData: false
		}
	},
	props: {
		userData: {},
		editUserInfo: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		editUserInfo () {
			this.editUserData = this.editUserInfo
		}
	},
	mounted () {
		this.editUserData = this.editUserInfo
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.userFormError = false
					this.$emit('personnalDataSubmit', this.userData)
				} else {
					this.userFormError = true
				}
			})
		},
		cancelAction () {
			this.editUserData = !this.editUserData
			this.$emit('cancelPersonnalData', this.editUserData)
		}
	}
}
</script>

<style scoped>

</style>
